module.exports = __webpack_public_path__ + "img/7.0d1452bb.png";